import {
    _getData,
    _postData,
    jsonPipe
} from "./fetch"

// import {
//     apiURL
// } from "../baseURL"

const articlesApiRoot = './static/articles/';
// const articlesApiRoot = apiURL + "GetArticle/";
const ArticlesApi = {
    get: articleId => {
               return _getData(`${articlesApiRoot}${articleId}.html`).then(data => data.text());
        // return _getData(`${articlesApiRoot}${articleId}`)
        //     .then(
        //         response => response.json()
        //     ).then(
        //         (result) => {
        //             let el = document.createElement('div');
        //             el.innerHTML = result;
        //             var fpvids = el.querySelectorAll(".flp6ScriptContainer");
        //             fpvids.forEach(element => {
        //                 element.id = "vid" + element.id;
        //                 element.dir = "ltr";
        //             });
        //             return el.querySelector("div.artiwrapper").outerHTML;
        //         }
        //     )
    },
    getVideoDetails: videoId =>
        _getData(`https://www.ynet.co.il/3rdparty/mobile/json/video/${videoId}/`)
        .then(jsonPipe)
}

// const FallenAPI = {
//     get: (id) => {
//         return _getData(`${apiURL}${(id && id > 0 ? `getone/${id}` : "getall")}`)
//             .then(jsonPipe);
//     }
// }

export {
    ArticlesApi
}


// WEBPACK FOOTER //
// ./src/Components/Services/Fetch/article.js